module.exports = __webpack_public_path__ + "img/in-work1.1b11f112.gif";